import React from "react"
import {graphql, Link, useStaticQuery} from "gatsby"
import * as Icon from "react-feather"

import MapImg from "../../assets/images/map.png"
import {toolsArr} from "../../pages/tools";

const query = graphql`
  {
    strapiSiteLogo {
      blackLogo {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      whiteLogo {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
    
    allStrapiServices(filter: { section: { eq: "ServicesPage" } }) {
      nodes {
        title
        slug
      }
    }
    
    allStrapiIndustries {
      nodes {
        title
        slug
      }
    }
  }
`

const Footer = () => {
  const data = useStaticQuery(query)
  const {
    strapiSiteLogo: { blackLogo }, allStrapiServices, allStrapiIndustries
  } = data
  console.log('data', data)
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer-area bg-f7fafd">
      <div className="containerxxx xxxw-full">
        <div className="row justify-content-center">
          {/*<div className="col-lg-1 col-sm-6">*/}
          {/*  <div className="single-footer-widget">*/}
          {/*    <div className="logo">*/}
          {/*      <Link to="/">*/}
          {/*        <img src={blackLogo.childImageSharp.fluid.src} alt="Logo" />*/}
          {/*      </Link>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}

          <div className="col-lg-2 col-sm-6">
            <div className="single-footer-widget pl-5">
              <h3>Company</h3>
              <ul className="list">
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/industries">Industries</Link>
                </li>
                <li>
                  <Link to="/portfolio">Portfolio</Link>
                </li>
                <li>
                  <Link to="/testimonials">Testimonials</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
                {/*<li>*/}
                {/*    <Link to="/features">*/}
                {/*        Features*/}
                {/*    </Link>*/}
                {/*</li>*/}
                {/*<li>*/}
                {/*    <Link to="/pricing">*/}
                {/*        Our Pricing*/}
                {/*    </Link>*/}
                {/*</li>*/}
                <li>
                  <a href="https://blog.ghanshyamdigital.com">Blogs</a>
                </li>
                <li>
                  <Link to="/tools">Free Tools</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-sm-6">
            <div className="single-footer-widget pl-5">
              <h3>Services We Offer</h3>
              <ul className="list">
                {allStrapiServices.nodes.map((service) => (
                  <li key={service.slug}>
                    <Link to={`/services/${service.slug}`}>{service.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-sm-6">
            <div className="single-footer-widget pl-5">
              <h3>Industries We Work With</h3>
              <ul className="list">
                {allStrapiIndustries.nodes.map((industry) => (
                  <li key={industry.slug}>
                    <Link to={`/industries/${industry.slug}`}>{industry.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-sm-6">
            <div className="single-footer-widget pl-5">
              <h3>Free Tools</h3>
              <ul className="list">
                {toolsArr.map((tool) => (
                    <li key={tool.slug}>
                      <Link to={`/tools/${tool.nav}`}>{tool.title}</Link>
                    </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-sm-6">
            <div className="single-footer-widget pl-5">
              <h3>Products</h3>
              <ul className="list">
                <li>
                  <Link to="/carousel">Hubspot All-In-One Hero Carousel</Link>
                </li>
                {/* Add more products here if needed */}
              </ul>
            </div>
          {/*</div>*/}

          {/*<div className="col-lg-3 col-sm-6">*/}
            <div className="single-footer-widget pl-5 pt-5">
              <h3>Address</h3>

              <ul className="footer-contact-info">
                <li>
                  <Icon.MapPin />
                  107, 1st Floor, 21st century business centre, Nr.World trade
                  centre, Ring Road, Surat - 395003, Gujarat, IN
                  {/*27 Division St, New York, */}
                  {/*<br />*/}
                  {/*NY 10002, USA*/}
                </li>
                <li>
                  <Icon.Mail />
                  Email:{" "}
                  <a href="mailto:contact@ghanshyamdigital.com">
                    contact@ghanshyamdigital.com
                  </a>
                </li>
                <li>
                  <Icon.PhoneCall />
                  Phone: <a href="tel:+918799074563">+91 87990 74563</a>
                </li>
              </ul>

              <ul className="social-links">
                <li>
                  <a
                    href="https://www.facebook.com/ghanshyamdigital/"
                    className="facebook"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon.Facebook />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/ghanshyamdg"
                    className="twitter"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon.Twitter />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/ghanshyamdigital_llp/"
                    className="instagram"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon.Instagram />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/ghanshyam-digital-llp/"
                    className="linkedin"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon.Linkedin />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <div className="copyright-area">
              <p>
                Copyright &copy; {currentYear} Ghanshyam Digital LLP. All rights
                reserved by Ghanshyam Digital LLP
              </p>
            </div>
          </div>
        </div>
      </div>

      <img src={MapImg} className="map" alt="map" />

      {/* Shape Images */}
      {/*<div className="shape1">*/}
      {/*  <img src={Shape1} width={200} height={200} alt="shape" />*/}
      {/*</div>*/}
      {/*<div className="shape8 rotateme">*/}
      {/*  <img src={Shape2} width={22} height={22} alt="shape" />*/}
      {/*</div>*/}
    </footer>
  )
}

export default Footer
